import { Button, Input, Spin, Tooltip } from "antd";
import {
  CopyOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import React, { useState } from "react";
import { ExternalLink } from "lucide-react";

function extractDateTime(timestamp) {
  const dateObj = new Date(timestamp);

  // Extract date in YYYY-MM-DD format
  const date = dateObj.toISOString().split("T")[0];

  // Extract time in HH:MM:SS format
  const time = dateObj.toISOString().split("T")[1].slice(0, 5) + " UTC";

  return { date, time };
}

function ReportDetails({ interviewData }) {
  const [reportLink, setReportLink] = useState(interviewData?.reportLink);

  const [copied, setCopied] = useState(false);
  const [loadingReAnalys, setLoadingReAnalys] = useState(false);
  const [reAnalysButtonState, setReAnalysButtonState] = useState(
    interviewData?.reAnalysisInProgress
  );

  let { date, time } = extractDateTime(
    interviewData?.interviewCompletionTimeStamp
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(reportLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className="px-[.8rem] py-[.3rem] mb-1">
      <div className="flex flex-col gap-[.6rem] w-full lg:w-[92%] lg:pl-[.9rem]">
        <div className="">
          <div className="text-[#475467] font-medium text-[.9rem]">
            Report link
          </div>
          <div className="relative w-full mt-1">
            <a
              href={reportLink || undefined}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                if (!reportLink) e.preventDefault();
              }}
              className={`block w-full rounded-[8px] py-[.45rem] px-3 break-all pr-14 border border-[#d9d9d9] bg-white text-[#206DC5] font-semibold text-[0.875rem] leading-relaxed no-underline transition-colors hover:text-[#175cd3] hover:underline min-h-[74px] ${
                reportLink ? "cursor-pointer" : "cursor-default text-gray-400"
              }`}
            >
              {reportLink || "No link available"}
            </a>
            <div className="absolute top-2 right-2 flex items-center gap-1">
              {!copied ? (
                <Button
                  type="text"
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.16602 12.5013C3.38945 12.5013 3.00116 12.5013 2.69488 12.3744C2.2865 12.2053 1.96204 11.8808 1.79288 11.4724C1.66602 11.1662 1.66602 10.7779 1.66602 10.0013V4.33464C1.66602 3.40121 1.66602 2.9345 1.84767 2.57798C2.00746 2.26438 2.26243 2.00941 2.57603 1.84962C2.93255 1.66797 3.39926 1.66797 4.33268 1.66797H9.99935C10.7759 1.66797 11.1642 1.66797 11.4705 1.79484C11.8789 1.96399 12.2033 2.28845 12.3725 2.69683C12.4993 3.00311 12.4993 3.3914 12.4993 4.16797M10.166 18.3346H15.666C16.5994 18.3346 17.0661 18.3346 17.4227 18.153C17.7363 17.9932 17.9912 17.7382 18.151 17.4246C18.3327 17.0681 18.3327 16.6014 18.3327 15.668V10.168C18.3327 9.23455 18.3327 8.76784 18.151 8.41132C17.9912 8.09771 17.7363 7.84275 17.4227 7.68296C17.0661 7.5013 16.5994 7.5013 15.666 7.5013H10.166C9.23259 7.5013 8.76588 7.5013 8.40937 7.68296C8.09576 7.84275 7.84079 8.09771 7.68101 8.41132C7.49935 8.76784 7.49935 9.23455 7.49935 10.168V15.668C7.49935 16.6014 7.49935 17.0681 7.68101 17.4246C7.84079 17.7382 8.09576 17.9932 8.40937 18.153C8.76588 18.3346 9.2326 18.3346 10.166 18.3346Z"
                        stroke="#98A2B3"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  className="p-1 flex items-center justify-center"
                  onClick={handleCopy}
                  title="Copy link"
                />
              ) : (
                <span className="font-medium top-3 right-3 text-[.8rem] text-green-600 px-1">
                  Copied!
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex gap-[1.2rem]">
          <div className="w-1/2">
            <div className="text-[#475467] font-medium text-[.9rem]">
              Timestamp
            </div>
            <Input
              disabled
              className="rounded-[8px] mt-1 py-[.48rem]"
              placeholder="Interview timestamp"
              value={date + "  |  " + time}
            />
          </div>
          <div className="w-1/2">
            <div className="text-[#475467] font-medium text-[.9rem]">
              Overall score
            </div>
            <Input
              disabled
              className="rounded-[8px] mt-1 py-[.48rem]"
              placeholder="Interview timestamp"
              value={
                Number(interviewData?.weightedReportScore)?.toFixed(2) ||
                0 + " / 5"
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportDetails;
